export default __webpack_public_path__ + "static/media/preview_sprinter.0295badb.jpg";